import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Box, Button, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Home.css';
import herobanner1 from '../assets/Images/herobanner1.png';
import herobanner2 from '../assets/Images/herobanner2.png';
import herobanner3 from '../assets/Images/herobanner3.jpg';
import ServicesSection from '../components/ServicesSection';
import VerticalSolutionsSection from '../components/VerticalSolutionsSection';
import ProcessStepsSection from '../components/ProcessStepsSection';
import WhyChooseSection from '../components/WhyChooseSection';
import StartupSection from '../components/StartupSection';
import TestimonialSlider from '../components/TestimonialSlider';
import CaseStudies from '../components/CaseStudies';
import AISection from '../components/AISection';
import Footer from '../components/Footer';

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);
const MotionButton = motion(Button);

const heroImages = [
  herobanner1,
  herobanner2,
  herobanner3,
];

const heroVariants = {
  hidden: { opacity: 0, y: 60 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.8,
      ease: [0.4, 0.2, 0.2, 1],
    },
  }),
};

const Home = () => {
  const [current, setCurrent] = useState(0);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="hero-banner full-height">
        <div className="hero-banner-slider-container">
          {heroImages.map((img, idx) => (
            <img
              key={img}
              src={img}
              alt="hero slide"
              className={`hero-banner-slide${idx === current ? ' active' : ''}`}
              style={{ zIndex: idx === current ? 2 : 1 }}
            />
          ))}
          <div className="hero-banner-overlay hero-banner-fade-left" />
        </div>
        <Container maxWidth="lg" className="hero-banner-content-container">
          <MotionBox
            className="hero-banner-content-no-box"
            initial="hidden"
            animate="visible"
            variants={{}}
          >
            <motion.div
              className="hero-accent-bar"
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 64, opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
            />
            <MotionTypography
              variant="overline"
              className="hero-tagline"
              initial="hidden"
              animate="visible"
              custom={0}
              variants={heroVariants}
            >
              Empowering Innovation
            </MotionTypography>
            <MotionTypography
              variant="h2"
              component="h1"
              className="hero-title"
              gutterBottom
              initial="hidden"
              animate="visible"
              custom={1}
              variants={heroVariants}
              style={{ color: '#112D4E' }}
            >
              We build digital <span className="hero-title-highlight">products</span>
              <br />
              <Box component="span" className="hero-highlight">that fuel your business</Box>
            </MotionTypography>
            <MotionTypography
              variant="h6"
              paragraph
              className="hero-subtitle hero-subtitle-dark"
              initial="hidden"
              animate="visible"
              custom={2}
              variants={heroVariants}
              style={{ maxWidth: 600 }}
            >
              Virves is your partner for software, mobile app, and web development. We deliver modern, scalable, and creative solutions for your business.
            </MotionTypography>
            {/* <MotionButton
              variant="contained"
              size="large"
              sx={{
                background: 'linear-gradient(90deg, #3F72AF 60%, #112D4E 100%)',
                color: '#F9F7F7',
                fontWeight: 700,
                fontSize: 18,
                px: 4,
                py: 1.5,
                borderRadius: 3,
                boxShadow: '0 4px 24px rgba(63,114,175,0.10)',
                mt: 2,
                textTransform: 'none',
                '&:hover': {
                  background: 'linear-gradient(90deg, #112D4E 60%, #3F72AF 100%)',
                },
              }}
              whileHover={{ scale: 1.06 }}
              whileTap={{ scale: 0.97 }}
              initial="hidden"
              animate="visible"
              custom={3}
              variants={heroVariants}
            >
              Get Started
            </MotionButton> */}
          </MotionBox>
        </Container>
      </div>


      {/* Modern Services Section */}
      <ServicesSection />

      {/* Vertical Solutions Section */}
      <VerticalSolutionsSection />

      {/* Process Steps Section */}
      <ProcessStepsSection />

      {/* Why Choose Section */}
      <WhyChooseSection />
      
      {/* Case Studies Section */}
      <CaseStudies />
      
      <StartupSection />
      
      {/* AI Section */}
      {/* <AISection /> */}
      
      {/* Testimonial Slider Section */}
      <TestimonialSlider />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home; 